module.exports = __webpack_public_path__ + "static/img/bg-index.5c3ab766.png";